import {EventsHandlersMap, MonitoredEventsMap} from './UserEventsMap'
import sendUserEvent from './sendUserEvent'
import isNeedToSendUserEvents from "./checks/isNeedToSendUserEvents";

export default function emitUserEvent(event, params) {
        if (!isNeedToSendUserEvents()) return false

        const handlers = EventsHandlersMap[event]
        if (!handlers) return sendUserEvent(event, params)

        handlers.forEach((handler) => {
            const { event: resultEvent, params: resultParams } = handler(event, params)

            if (Object.values(MonitoredEventsMap).includes(resultEvent))
                return sendUserEvent(resultEvent, resultParams)
        })
}



// WEBPACK FOOTER //
// ./web/js/userEvents/emitUserEvent.js